import React from 'react';
import { HolidayActivityFill } from "./WallPlannerActivityBlocks";
import { daysBetween } from '@shared/utils/DateUtils';
import { Moment } from "moment";
import { Birthday } from '@shared/models/user.models';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';

export function NonWorkingDayBlock(props: Props) {
  const {activity, firstDateOnCalendar} = props;
  const days = 1;

  const customImage = (activity.amImage || activity.pmImage || '').replace('.svg', '-grey.svg').toLowerCase().trim();

  return (
    <HolidayActivityFill start={daysBetween(activity.date, firstDateOnCalendar)}
                         days={days}
                         fill={Colours.veryLightGrey}
                         outline={'#A6B4B4'}
                         textColour={Colours.black}
                         title={activity.label}>
      <Contents>
        {(customImage) ? <>
          <IconImage src={"/assets/icons/outline-icons/" + customImage} alt={""} />
        </> : <>
          <IconImage src={"/assets/icons/outline-icons/notworking-grey.svg"} alt={""} />
        </>}

        {props.children && <>{props.children}</>}
      </Contents>
    </HolidayActivityFill>
  )
}

interface Props {
  activity: any;
  children?: any;
  firstDateOnCalendar: Moment;
  weeksInMonth: number;
  birthday?: Birthday;
}

const Contents = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const IconImage = styled.img`
  width: 16px;
  height: 16px;
  justify-self: center;
  align-self: center;
`
